module.exports = __webpack_public_path__ + "media/images/common/header_menu_qa-d14c6687434a4e6fde8b3703e3c92bc8.png";